import type { BaseUser } from '@frontend/api';

import type { HistoryMessage } from './messageTypes';

export const AGENT_TYPE = {
  QUOTE: 'quote',
  REQS_REVIEW: 'rr',
  ANALYTICS: 'analytics',
} as const;

export type AgentType = (typeof AGENT_TYPE)[keyof typeof AGENT_TYPE];

export type AgentConversationListData = {
  uuid: string;
  name: string;
  createdBy: BaseUser & { id: number };
  agentType: AgentType;
  created: string;
  updated: string;
  deletedAt: string | null;
};

export type AgentConversation = AgentConversationListData & {
  history: HistoryMessage[];
  baseSystemPrompt: string | null;
  modelKey: string | null;
};
